module.exports = "/assets/data/0aa1d802cf88b03afbaa5885c2e05c2b-NP44.data.json";